<template>
    <div v-wechat-title="title">
        <div class="margin10 margin-none-h align-left">
            <el-input type="textarea" :rows="4" v-model="textarea" :placeholder="`请录入...`"></el-input>
        </div>
        <CloseButton ref="close-btn" type="confirm" @confirm="save" :msg="msg"> </CloseButton>
    </div>
</template>
<script>
export default {
    name: `ReviveExceptionalCase`,
    props: {

    },
    data() {
        return {
            title: this.$route.query.btn_name,
            token: this.$route.query.token,
            surgeryId: this.$route.query.surgery_id,
            msg: `closeWindow`,
            textarea: ``
        }
    },
    created() {
        sessionStorage.setItem(`token`, this.token)
        this.loadSurgery().then(data => {
            this.textarea = data.exceptional_case
        })
    },
    computed: {
    },
    methods: {
        loadSurgery() {
            if (this.surgeryId) {
                return this.myaxios.get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
            } else {
                return Promise.resolve({})
            }
        },
        save() {
            let that = this
            return new Promise((resolve) => {
                let req = that.myaxios.put(`/api/Intraoperative/Anaesthesia/SaveReviveExceptionalCase/${this.$route.query.surgery_id}?remark=${this.textarea}`)
                req.then(data => {
                    // that.data = { surgeryId: this.$route.query.surgery_id }
                    this.$refs[`close-btn`].close()
                }).catch(e => { console.log(e) })
            })
        }
    },
    watch: {
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/ReviveExceptionalCase.vue